<template>
  <select
    @input="event => { $emit('input', event.target.value) }"
    class="form-control"
    v-model="selectedOption"
    style="text-transform: uppercase;"
  >
    <option v-if="all" value="TODAS">TODAS</option>
    <option value="ABATEDOUROS">ABATEDOUROS</option>
    <option value="ABATEDOURO DE AVES">ABATEDOURO DE AVES</option>
    <option value="ABATEDOURO SUINO">ABATEDOURO SUINO</option>
    <option value="ADMINISTRATIVO">ADMINISTRATIVO</option>
    <option value="AGRICULTURA">AGRICULTURA</option>
    <option value="AGROTOXICOS">AGROTÓXICOS</option>
    <option value="Amostras Pesticidas">Amostras Pesticidas</option>
    <option value="Armazenamento">Armazenamento</option>
    <option value="ATERRO">ATERRO</option>
    <option value="AVICULTURA">AVICULTURA</option>
    <option value="Bandagens, algodão, seringa, agulhas e frascos">Bandagens, algodão, seringa, agulhas e frascos</option>
    <option value="BATATA SEMENTE">BATATA SEMENTE</option>
    <option value="Beneficiamento de Grãos">Beneficiamento de Grãos</option>
    <option value="BOVINOCULTURA">BOVINOCULTURA</option>
    <option value="CAFÉ">CAFÉ</option>
    <option value="Centro de distribuição">Centro de distribuição</option>
    <option value="CERVEJA CHOPE">CERVEJA e CHOPE</option>
    <option value="CLASSE I">CLASSE I</option>
    <option value="COMPOSTAGEM">COMPOSTAGEM</option>
    <option value="Concessionária">Concessionária</option>
    <option value="CONDOMÍNIO LOGÍSTICO">CONDOMÍNIO LOGÍSTICO</option>
    <option value="CONJUNTO HABITACIONAL">CONJUNTO HABITACIONAL</option>
    <option value="CONTROLE DE PRAGAS">CONTROLE DE PRAGAS</option>
    <option value="DIVERSAS">DIVERSAS</option>
    <option value="Diversos contaminados">Diversos contaminados</option>
    <option value="Eletronicos Toner">Eletrônicos Toner</option>
    <option value="EMBALAGENS VAZIAS">EMBALAGENS VAZIAS</option>
    <option value="Esparadrapos, gazes, seringas, agulhas e outros">Esparadrapos, gazes, seringas, agulhas e outros</option>
    <option value="ENERGIA">ENERGIA</option>
    <option value="Explantes">Explantes</option>
    <option value="Explantes Grupo A1">Explantes Grupo A1</option>
    <option value="EXTRA-ATIV">EXTRA-ATIV</option>
    <option value="FABRICA DE FARINHA E OSSO">FÁBRICA DE FARINHA E OSSO</option>
    <option value="FABRICA DE RACAO / FARINHA">FÁBRICA DE RAÇÃO / FARINHA</option>
    <option value="FAENA DE POLLO">FAENA DE POLLO</option>
    <option value="FARMACIA VETERINARIA">FARMÁCIA VETERINÁRIA</option>
    <option value="FÉCULA">FÉCULA</option>
    <option value="FERTILIZANTES">FERTILIZANTES</option>
    <option value="GERENCIADORA DE RESÍDUO">GERENCIADORA DE RESÍDUO</option>
    <option value="GRANJAS">GRANJAS</option>
    <option value="GRAOS">GRÃOS</option>
    <option value="Grupo B">Grupo B</option>
    <option value="INCUBATORIO">INCUBATÓRIO</option>
    <option value="INDÚSTRIA">INDÚSTRIA</option>
    <option value="INDUSTRIAL">INDUSTRIAL</option>
    <option value="Infectantes Grupo A / E">Infectantes Grupo A / E</option>
    <option value="Grupo B">Infectantes Grupo B</option>
    <option value="IRRIGAÇÃO">IRRIGAÇÃO</option>
    <option value="LABORATÓRIO DE ANÁLISE">LABORATÓRIO DE ANÁLISE</option>
    <option value="Lâmpadas">Lâmpadas</option>
    <option value="Lâmpadas Fluorescentes">Lâmpadas Fluorescentes</option>
    <option value="Lâmpadas inteiras ou quebradas">Lâmpadas inteiras ou quebradas</option>
    <option value="LAVADOR BATATAS">LAVADOR de BATATAS</option>
    <option value="Lavador de Veículos">Lavador de Veículos</option>
    <option value="LEITE">LEITE</option>
    <option value="LORENZ">LORENZ</option>
    <option value="LOTEAMENTO">LOTEAMENTO</option>
    <option value="LOJA AGROPECUARIA">LOJA AGROPECUÁRIA</option>
    <option value="Matrizeiro">Matrizeiro</option>
    <option value="Metalúrgica">Metalúrgica</option>
    <option value="Moagem de Grãos">Moagem de Grãos</option>
    <option value="MOINHO">MOINHO</option>
    <option value="Pilhas e baterias">Pilhas e baterias</option>
    <option value="PISCICULTURA">PISCICULTURA</option>
    <option value="PLANTA DE BALANCEADO">PLANTA DE BALANCEADO</option>
    <option value="PRODUTOS AGRICOLAS">PRODUTOS AGRICOLAS</option>
    <option value="Produção de Ovos">Produção de Ovos</option>
    <option value="PORTE E USO DE MOTOSSERRA">PORTE E USO DE MOTOSSERRA</option>
    <option value="POSTO">POSTO</option>
    <option value="RACOES BALANCEADAS">RAÇÕES BALANCEADAS</option>
    <option value="RESIDUOS">RESÍDUOS</option>
    <option value="Resíduos de Serviço de Saúde - Grupo A5">Resíduos de Serviço de Saúde - Grupo A5</option>
    <option value="RESÍDUOS ELETRÔNICOS">RESÍDUOS ELETRÔNICOS</option>
    <option value="Residuos liquidos quimicos">RESÍDUOS liquidos quimicos</option>
    <option value="SEMENTES">SEMENTES</option>
    <option value="SILVICULTURA">SILVICULTURA</option>
    <option value="Sobras de análises">Sobras de análises</option>
    <option value="SUINOCULTURA">SUINOCULTURA</option>
    <option value="TANQUE DE COMBUSTÍVEL">TANQUE DE COMBUSTÍVEL</option>
    <option value="TERMINAL CALCÁRIO">TERMINAL CALCÁRIO</option>
    <option value="TRANSPORTE">TRANSPORTE</option>
    <option value="TRANSPORTE DE RESÍDUOS">TRANSPORTE DE RESÍDUOS</option>
  </select>
</template>

<script>
export default {
  name: "atividades",
  props: {
    value: null,
    all: false
  },
  data() {
    return {
      selectedOption: null
    };
  },
  mounted() {
    this.selectedOption = this.value;
  },
  watch: {
    value: function(newValue) {
      this.selectedOption = newValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/custom/Atividades.vue